import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import usePermissions from '../../hooks/usePermissions';
import { ROUTE_PERMISSIONS } from '../../config/permissions';

export default function ProtectedRoute({ allowedRoles }) {
  const { user, loading } = useAuth();
  const { hasPermission } = usePermissions();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0B5D1E]"></div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  // Check route-level permissions for admin pages
  const requiredPerms = ROUTE_PERMISSIONS[location.pathname];
  if (requiredPerms && user.role === 'admin' && !hasPermission(...requiredPerms)) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="text-6xl mb-4">🔒</div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h1>
          <p className="text-gray-500 mb-6">You don't have permission to access this page.</p>
          <a href="/admin" className="text-[#0B5D1E] hover:underline font-semibold">Go to Dashboard</a>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
